/**
 * Flowbox — inicializa las galerías de contenido social del tema.
 *
 * Reescrito en JavaScript puro el 2026-08-26. El original eran 175 líneas de
 * jQuery, y el 8.3.2 no carga jQuery. Funcionaba de rebote porque
 * huk-megamenu.js trae jQuery 2.2.3 empaquetado y lo registra como window.$;
 * en cuanto se quitaran las copias locales del megamenú, Flowbox habría
 * dejado de funcionar sin ninguna señal.
 *
 * Cambios respecto al original:
 * - Fuera el bloque `productFlowboxImage` (~90 líneas). Construía marcado de
 *   Dawn —`product__media-item`, `modal-opener`, `.product-media-modal__content`—
 *   con un id de sección de otra tienda escrito a mano. Ninguno de esos
 *   selectores existe en Symmetry, ni en el 6.0.0 ni en el 8.3.2: nunca llegó
 *   a ejecutarse.
 * - Los cuatro objetos `window.*flowboxPromotions`, que eran copias del mismo
 *   bucle, pasan a una sola tabla de montajes.
 * - Fuera los console.log de depuración.
 * - Cada montaje se inicializa una sola vez, y al recargar una sección desde
 *   el editor solo se recorre esa sección, no la página entera.
 *
 * Cómo se declara un montaje en el marcado:
 *
 *   <div id="js-flowbox-flow1234"
 *        class="js-flowbox-section"
 *        data-key="..." data-id="#js-flowbox-flow1234" data-locale="es-MX"></div>
 */
(function () {
  'use strict';

  // Cada clase de montaje añade sus propios parámetros a la llamada de init.
  var MOUNTS = [
    {
      selector: '.js-flowbox-section',
      params: function () { return {}; },
    },
    {
      selector: '.collection-flowbox-section',
      params: function (el) {
        return { tags: [el.dataset.tags], tagsOperator: el.dataset.tagoperator };
      },
    },
    {
      // Ojo al plural: esta variante pide un producto concreto.
      selector: '.product-flowbox-sections',
      params: function (el) { return { productId: el.dataset.product }; },
    },
    {
      selector: '.product-flowbox-section',
      params: function (el) { return { tags: [el.dataset.tags] }; },
    },
  ];

  function initMount(el, mount) {
    if (el.dataset.flowboxInitialised === 'true') return;

    var key = el.dataset.key;
    if (!key) return;

    var config = {
      container: el.dataset.id || '#' + el.id,
      key: key,
      locale: el.dataset.locale,
    };

    var extra = mount.params(el);
    for (var name in extra) {
      if (Object.prototype.hasOwnProperty.call(extra, name) && extra[name] !== undefined) {
        config[name] = extra[name];
      }
    }

    el.dataset.flowboxInitialised = 'true';
    window.flowbox('init', config);
  }

  function init(root) {
    if (typeof window.flowbox !== 'function') return;

    var scope = root || document;
    MOUNTS.forEach(function (mount) {
      scope.querySelectorAll(mount.selector).forEach(function (el) {
        initMount(el, mount);
      });
    });
  }

  init(document);

  // El editor de temas vuelve a pintar la sección; hay que montar lo nuevo.
  document.addEventListener('shopify:section:load', function (event) {
    var section = document.getElementById('shopify-section-' + event.detail.sectionId);
    if (section) init(section);
  });
})();
